import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { CameraPermissionHost } from '@/app/CameraPermissionHost';
import { isClinicEntry } from '@/clinic/routing';
import { registerPwaUpdates } from '@/pwa/registerUpdates';
import { initResearchUploads } from '@/research';

const App = lazy(() => import('./App'));

const ClinicApp = lazy(() =>
  import('@/clinic/ClinicApp').then((mod) => ({ default: mod.ClinicApp }))
);

const clinic = isClinicEntry(window.location);

if (!clinic) {
  initResearchUploads();
}

if (import.meta.env.PROD) {
  registerPwaUpdates();
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Missing #root');
}

createRoot(root).render(
  <StrictMode>
    <CameraPermissionHost />
    <Suspense
      fallback={
        <div className="ma-screen">
          <p className="p-6 text-ma-muted">Loading…</p>
        </div>
      }
    >
      {clinic ? <ClinicApp /> : <App />}
    </Suspense>
  </StrictMode>
);
